import AddOfficeExpense from "../../../../components/company/expense/office-expense/add-expense";

export default function AddOfficeExpensePage(){
    return <AddOfficeExpense />
}